import { CommApiInstance } from "Utils/CommApiInstance";


const MembLvdRqstApi = async (
) => {
    return await CommApiInstance.post(`memb/lvd/rqst`,{
        apiBody: {
        }
    })
    .then((Resp) => Resp.data.apiBody);
}

export default MembLvdRqstApi;